import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

class VerOfer2 extends React.Component {
    state={
        argsDocum: {
            codigoOferta: this.props.idLista.codigoOferta,
            descrOferta: this.props.idLista.descrOferta,
            estadoOferta: this.props.idLista.estadoOferta,
            _id: this.props.idLista._id
        },
        confirmaAct: false,
        open: false
    }

    handleChange = (ev) => {
        if (this.props.permiteUpdate){
            this.setState({confirmaAct: false})
            if(ev.target.name !== "codigoOferta"){
                const argsDocum = this.state.argsDocum
                if(ev.target.name === "estadoOferta"){
                    if(argsDocum.estadoOferta === true){
                        argsDocum[ev.target.name] = false
                    }else{
                        argsDocum[ev.target.name] = true
                    }
                }else{
                    argsDocum[ev.target.name] = ev.target.value
                }
                this.setState({argsDocum});
            }
        }
    }

    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    render(){
        const {argsDocum, confirmaAct, open} = this.state;
        return(
            <div>
                <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                    <i className="large hand point down yellow icon"></i>
                    Oferta
                </button>
                <div style={this.props.styles.box}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
                        <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Código</label>
                                        <Form.Input autoComplete="off" name="codigoOferta" id="codigoOferta" value={argsDocum.codigoOferta} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoOferta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Descripción</label>
                                        <Form.Input autoComplete="off" name="descrOferta" id="descrOferta" value={this.props.permiteUpdate?argsDocum.descrOferta:this.props.idLista.descrOferta} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrOferta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>

                                    <Form.Field>
                                        <label style={this.props.styles.label}>Inactiva / Activa</label>
                                        <Form.Checkbox name="estadoOferta" id="estadoOferta" className='ui fitted toggle checkbox' checked={argsDocum.estadoOferta} onChange={this.handleChange}/>
                                    </Form.Field>


                                    {/* <Form.Field>
                                        <label style={this.props.styles.label}>% Impuesto</label>
                                        <Form.Input autoComplete="off" name="porcOferta" id="porcOferta" type="number" step="0.01" value={argsDocum.porcOferta} onChange={this.handleChange} placeholder='% Impuesto' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'porcOferta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field> */}

                                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>

                                {
                                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }

                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default VerOfer2
